import Icon from 'veui/components/Icon'
import { IconArrowToBottom } from 'dls-icons-vue'

Icon.register('arrow-to-bottom', IconArrowToBottom)
